import { publish, subscribe } from '@wh/message-bus';
import { ObSessionStateType } from '@central-products/interface-obsession-service';
import { ACCOUNT_ACTION_IDS } from '@central-products/interface-account-actions';
import { deposit } from '@sitebase/pre-integrated-header/default-features';
import { getValueForDevice, updateDepositUrl } from '../../utils';
import './styles.scss';

const ACCOUNT_ACTION_REQUESTED = 'wh.common.event.account.action.requested';
const DEPOSIT_MODAL_OPENED = 'wh.common.event.ui.header.deposit.opened';
const OBSESSION_STATE_CHANGED = 'wh.common.event.obsession.state.changed';

const DEPOSIT_NORMAL_TYPE = 'DEPOSIT';

const openDeposit = () => {
  publish(deposit.commands.open({ type: DEPOSIT_NORMAL_TYPE }));
};

const subscribeTopics = () => {
  let depositRequested = false;
  let sessionSynchronized = false;

  subscribe({
    topic: ACCOUNT_ACTION_REQUESTED,
    callback: ({ data }) => {
      if (data && data.actionId === ACCOUNT_ACTION_IDS.DEPOSIT_START) {
        depositRequested = true;
        if (sessionSynchronized) {
          openDeposit();
        }
      }
    },
  });

  subscribe({
    topic: OBSESSION_STATE_CHANGED,
    callback: ({ data }) => {
      sessionSynchronized = data.state === ObSessionStateType.SESSION_EXISTS;
      if (depositRequested && sessionSynchronized) {
        openDeposit();
      }
    },
  });

  subscribe({
    topic: DEPOSIT_MODAL_OPENED,
    callback: () => {
      depositRequested = false;
    },
  });
};

export const depositPlugin = {
  beforeRender({ header, params, productConfig }) {
    header.actions.children.unshift({
      type: '@sitebase/deposit-button',
      children: [],
      data: {
        id: 'pi-header__deposit-button',
        eventSource: params.eventSource,
      },
    });

    header.actions.children.push({
      type: '@sitebase/deposit',
      data: {
        amount: params.amount,
        amountButtons: params.amountButtons,
        countryLevelConfig: params.countryLevelConfig,
        blockedSchemesUrl: params.blockedSchemesUrl,
        depositLimitsPageUrl: params.depositLimitsPageUrl,
        chatUrl: params.chatUrl,
        currency: params.currency,
        depositUrl: updateDepositUrl(getValueForDevice(params.depositUrl)),
        hideDLTforCountryCodes: params.hideDLTforCountryCodes,
        forceHideDLT: params.forceHideDLT,
        obUrl: getValueForDevice(params.obUrl),
        pmtApiUrl: params.pmtApiUrl,
        pmtMethodsStrategy: params.pmtMethodsStrategy,
        pmtSource: getValueForDevice(params.pmtSource),
        showCloseButton: params.showCloseButton,
        showOtherDepositMethodsLink: params.showOtherDepositMethodsLink,
        tdsTermUrl: params.tdsTermUrl,
        tdsTermUrlV2: params.tdsTermUrlV2,
        jurisdiction: productConfig.jurisdiction,
        disableApplePay: params.disableApplePay,
      },
      children: [],
    });
    subscribeTopics();
  },
};
